import { Quicksand } from 'next/font/google';
import styles from '../shop.module.css';
const poppins = Quicksand({
  subsets: ["latin"],
  weight: [ "400", "600","300","400","700"]
});
export default function Sidebar() {
  return (
    <aside className={styles.sidebar +" "+ poppins.className}>
      <div className={styles.sidebarContent}>
        <h2 className={styles.sidebarTitle}>Categories</h2>
        <ul className={styles.categoryList}>
          <li>Supplements</li>
          <li>Vitamins</li>
          <li>Proteins</li>
          <li>Pre-workout</li>
          <li>Recovery</li>
          <li>Packs</li>
        </ul>

        <h3 className={styles.filterTitle}>Filter By</h3>

        <div className={styles.filterSection}>
          <h4>Rating</h4>
          <div className={styles.ratingFilter}>
            <label><input type="checkbox" /> 5 Stars</label>
            <label><input type="checkbox" /> 4+ Stars</label>
            <label><input type="checkbox" /> 3+ Stars</label>
          </div>
        </div>
      </div>
    </aside>
  );
}
